import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Form for rule_type='upgrade_pct_of_tier' or 'maintain_pct_of_tier' (D-038).
 * rule_value shape: { value: <number> } — percentage of creators per tier.
 * Example: 20 → 20% of creators per tier should rank-up / maintain.
 *
 * Props:
 *   variant: 'upgrade' | 'maintain' — only affects the help text label
 */
const PctOfTierRuleForm = ({ value, onChange, disabled, variant = 'upgrade' }) => {
  const { t } = useTranslation();
  const v = value?.value ?? '';

  const labelKey =
    variant === 'maintain'
      ? 'admin.objectiveRules.form.pctOfTier.maintainHelp'
      : 'admin.objectiveRules.form.pctOfTier.upgradeHelp';
  const fallback =
    variant === 'maintain'
      ? '% of creators per tier expected to maintain their current tier this month.'
      : '% of creators per tier expected to rank-up this month.';

  return (
    <div className="space-y-2">
      <label className="block text-xs uppercase tracking-widest text-muted-foreground font-semibold">
        {t('admin.objectiveRules.form.pctOfTier.value', 'Percentage of tier population')}
      </label>
      <div className="flex items-center gap-2">
        <input
          type="number"
          step="any"
          disabled={disabled}
          value={v}
          onChange={(e) =>
            onChange({ value: e.target.value === '' ? null : Number(e.target.value) })
          }
          className="w-full px-3 py-2 rounded-lg bg-card border border-border text-foreground text-base tabular-nums outline-none focus:border-accent focus:ring-1 focus:ring-accent/30 disabled:opacity-60"
          placeholder="20"
        />
        <span className="text-sm font-semibold text-muted-foreground">%</span>
      </div>
      <p className="text-xs text-muted-foreground">{t(labelKey, fallback)}</p>
    </div>
  );
};

export default PctOfTierRuleForm;
